import { exportToWord } from '../utils/exportToWord';
import './PolicyStyles.css'; // Ensure the correct path to your CSS file


const CargoHandlingAndSecurityPolicy = ({
  clientName,
  clientAddress,
  effectiveDate,
  companyNumber,
  transportManagerContact,
  securityServiceContact,
}) => {
  // Handle the export functionality
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Cargo_Handling_Security_Policy.docx");
  };

  return (
    <div className="policy-container">
      <h3 className="policy-title">Accident & Incident Management Policy</h3>
      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> { companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">Purpose</h4>
      <p className="section-content">
        The purpose of this policy is to establish procedures for handling and securing cargo to ensure the safety and security of both the cargo and the vehicle during transportation. This includes guidelines for safe loading, unloading, and securing of cargo, as well as steps to prevent theft or damage during transit.
      </p>

      <h4 className="section-title">Scope</h4>
      <p className="section-content">
        This policy applies to all employees, contractors, and third-party providers involved in the transportation of cargo for the company. It includes:
      </p>
      <ul>
        <li>All vehicles used for transporting cargo.</li>
        <li>All cargo handling, loading, and unloading processes.</li>
        <li>Security measures to prevent cargo theft and damage.</li>
      </ul>

      <h4 className="section-title">Responsibilities</h4>
      <p className="section-content"><strong>Drivers:</strong> Drivers are responsible for ensuring that cargo is properly secured, checking that load restraints are in place, and following safety procedures for loading/unloading.</p>
      <p className="section-content"><strong>Transport Managers:</strong> Transport Managers are responsible for ensuring that employees are trained in cargo handling and security procedures, and for ensuring compliance with these policies.</p>
      <p className="section-content"><strong>Security Personnel:</strong> Security personnel are responsible for monitoring cargo during transit, verifying that security measures are followed, and reporting any incidents of theft or damage.</p>

      <h4 className="section-title">Cargo Handling Procedure</h4>
      <p className="section-content">
        The following procedures must be followed when handling cargo:
      </p>
      <ul>
        <li><strong>Loading:</strong> Cargo should be loaded in a manner that ensures it is stable and secured. Items should be placed to prevent shifting during transit.</li>
        <li><strong>Weight Distribution:</strong> Ensure proper weight distribution to avoid overloading any part of the vehicle, which can cause safety risks.</li>
        <li><strong>Restraints:</strong> Use appropriate load restraints (e.g., tie-downs, straps, etc.) to secure the cargo. The restraints should be checked periodically during transit.</li>
        <li><strong>Unloading:</strong> When unloading, ensure that the cargo is carefully handled to avoid injury or damage. Ensure the unloading area is safe and clear of obstacles.</li>
      </ul>

      <h4 className="section-title">Cargo Security</h4>
      <p className="section-content">
        To ensure the security of cargo during transit, the following measures must be observed:
      </p>
      <ul>
        <li><strong>Locking Vehicles:</strong> All vehicles must be securely locked when parked, and any cargo compartments must be locked when not in use.</li>
        <li><strong>Monitoring:</strong> Cargo should be monitored using GPS tracking systems, and regular checks should be conducted to ensure the cargo is secure.</li>
        <li><strong>Access Control:</strong> Limit access to the cargo area during transit to authorized personnel only. Unauthorized access must be reported immediately.</li>
        <li><strong>Incident Reporting:</strong> Any incidents involving theft, damage, or attempted theft must be reported immediately to the Transport Manager and security personnel.</li>
      </ul>

      <h4 className="section-title">Emergency Procedures</h4>
      <p className="section-content">
        In the event of an emergency, such as a cargo theft or vehicle accident, the following steps should be taken:
      </p>
      <ul>
        <li><strong>Stop the vehicle:</strong> Pull over to a safe location and ensure that the vehicle and cargo are secured.</li>
        <li><strong>Contact Authorities:</strong> Call the appropriate authorities if the cargo has been stolen or damaged. This includes law enforcement or emergency services.</li>
        <li><strong>Notify the Transport Manager:</strong> Immediately inform the Transport Manager of the situation and follow any further instructions provided.</li>
        <li><strong>Complete an Incident Report:</strong> After the incident, complete an incident report with details of the event and any corrective actions taken.</li>
      </ul>

      <h4 className="section-title">Emergency Contact Information</h4>
      <p className="section-content">
        The following contact numbers should be used in the event of an emergency:
      </p>
      <ul>
        <li><strong>Transport Manager:</strong> {transportManagerContact || "[Insert Contact Number]"}</li>
        <li><strong>Security Service:</strong> {securityServiceContact || "[Insert Contact Number]"}</li>
        <li><strong>Local Authorities:</strong> [Insert Local Authorities Contact Number]</li>
      </ul>

      <h4 className="section-title">Record Keeping</h4>
      <p className="section-content">
        A record of all cargo handling and security incidents must be maintained, including the following details:
      </p>
      <ul>
        <li>Details of the cargo being transported (type, weight, etc.).</li>
        <li>Information on any incidents or security breaches, including theft or damage.</li>
        <li>Actions taken to resolve issues and prevent future occurrences.</li>
      </ul>

      <h4 className="section-title">Conclusion</h4>
      <p className="section-content">
        The Cargo Handling & Security Policy ensures the safety and security of all cargo being transported by the company. By following these guidelines, we aim to minimize risks and protect both the cargo and our employees.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I have read, understood, and agree to comply with the Cargo Handling & Security Policy. I understand my responsibilities for cargo security and handling.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is hereby in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      {/* Export to Word Button */}
      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-500 text-white px-6 py-2 rounded-lg hover:bg-green-600 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default CargoHandlingAndSecurityPolicy;
